export default __webpack_public_path__ + "static/media/protection-for-my-health-icon.4dc127c2.svg";